module.exports = {
    NorthgatePricing:{
        suiteCleaning: 100,
        parking: 175,
        communityFee:95,
        flexFeeCoefficient: 0.1
    }
}